/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const instanceLevelMappingCreateRequestSchema = z.object({
  itemLevel: z.int(),
  sourceLevel: z.int(),
});
